module.exports = __webpack_public_path__ + "img/智慧林长制管理平台.11fdd378.png";